import { Typography } from "@mui/material"
import NextImage from "common/bit/NextImage"
import { StyledLink } from "reusable/wrappers/BodyText"
import styled from "styled-components"

const StyledCarWrapper = styled.div<{ $margin: number }>`
  display: flex;
  flex-direction: column;
  width: calc(50% - 10px);
  margin-top: ${(p) => p.$margin && `${p.$margin}px`};
  /* width: 50%; */
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledImageContainer = styled.div`
  overflow: hidden;
  height: 300px;
  margin-top: 10px;
`
const StyledImage = styled(NextImage)`
  transition: 1s;
  :hover,
  :focus {
    transform: scale(1.2);
  }
`

// const StyledImage = styled.img`
//   height: 300px;
//   padding-left: 20px;
//   object-fit: cover;
//   margin-top: 10px;
//   ${(p) => p.theme.breakpoints.down("sm")} {
//     padding-left: 0px;
//     width: 100%;
//   }
// `

type CarWrapperProps = {
  title: string
  src: string
  link: string
  marginTop?: number
}

const CarWrapper = ({ title, src, link, marginTop }: CarWrapperProps) => {
  return (
    <StyledCarWrapper $margin={marginTop || 0}>
      <Typography variant="subtitle1">{title}</Typography>
      <StyledImageContainer
        style={{
          width: "100%",
          height: 400,
        }}
      >
        <StyledImage image={{ imageUrl: src, alt: title }} />
      </StyledImageContainer>
      <StyledLink $color=" #101010;" href={link} $margin={10}>
        למידע נוסף
      </StyledLink>
    </StyledCarWrapper>
  )
}

export default CarWrapper
